import React, { memo } from 'react';
import './css/HomePage1Section21.css';
import PropTypes from 'prop-types';
import SmallGamesWidget1 from '../../../uiElements/gamesWidgets/smallGamesWidget1/SmallGamesWidget1';
import SleekCarouselGamesWidget1 from '../../../uiElements/gamesWidgets/sleekCarouselGamesWidget1/SleekCarouselGamesWidget1';

function HomePage1section21(props) {
    const { showDesktop, showMobile, primaryBackgroundColor, smaller } = props;

    return (
        <div className="homepage1-section21-container-container x-center">
            {showDesktop ? (
                <div className="homepage1-section21-container-desktop">
                    <SleekCarouselGamesWidget1 primaryBackgroundColor={primaryBackgroundColor} smaller={smaller} />
                </div>
            ) : null}
            {showMobile ? (
                <div className="homepage1-section21-container-mobile x-center">
                    <div className="homepage1-section21-games">
                        <SmallGamesWidget1 scheduled={false} />
                        <SmallGamesWidget1 scheduled />
                    </div>
                </div>
            ) : null}
        </div>
    );
}

HomePage1section21.propTypes = {
    showDesktop: PropTypes.bool,
    showMobile: PropTypes.bool,
    primaryBackgroundColor: PropTypes.bool,
    smaller: PropTypes.bool,
};

HomePage1section21.defaultProps = {
    showDesktop: true,
    showMobile: true,
    primaryBackgroundColor: false,
    smaller: false,
};

export default memo(HomePage1section21);
